import React from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { MapPin } from "lucide-react";

export default function MasterLocations() {
  return (
    <MasterDataPage
      title="Locations"
      subtitle="Multi-location support — primary calibration center + satellite shops"
      entity="locations"
      testId="locations"
      icon={MapPin}
      defaultForm={{ name: "", address: "", city: "", state: "", zip_code: "", phone: "", manager_name: "", bay_count: 4, is_primary: false }}
      fields={[
        { key: "name", label: "Location Name", required: true, span: 2 },
        { key: "address", label: "Street Address", required: true, span: 2 },
        { key: "city", label: "City" },
        { key: "state", label: "State" },
        { key: "zip_code", label: "ZIP" },
        { key: "phone", label: "Phone" },
        { key: "manager_name", label: "Site Manager" },
        { key: "bay_count", label: "Number of Bays", type: "number" },
        { key: "timezone", label: "Timezone", type: "select", options: ["America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "America/Sao_Paulo"] },
        { key: "is_primary", label: "Primary Location", type: "checkbox", checkboxLabel: "Use as default for new jobs" },
      ]}
      columns={[
        { key: "name", label: "Name" },
        { key: "city", label: "Location", render: (r) => [r.city, r.state].filter(Boolean).join(", ") || "—" },
        { key: "manager_name", label: "Manager" },
        { key: "bay_count", label: "Bays" },
        { key: "jobs_count", label: "Jobs" },
        { key: "is_primary", label: "Primary", render: (r) => r.is_primary ? "⭐" : "—" },
      ]}
    />
  );
}
